import { objectWithoutProperties as _objectWithoutProperties } from "../../../_virtual/_rollupPluginBabelHelpers.js";
import 'react';
import { jsx } from '@emotion/core';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import useStores from "../../../hooks/useStores.js";
import ResizeHandle from "./ResizeHandle.js";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "yc55n3",
  styles: "padding-left:2px;"
} : {
  name: "yc55n3",
  styles: "padding-left:2px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var DrawableTextField = function DrawableTextField(_ref) {
  var _assignmentStore$defa;

  var field = _ref.field,
      selected = _ref.selected,
      rest = _objectWithoutProperties(_ref, ["field", "selected"]);

  var _useStores = useStores(),
      assignmentStore = _useStores.assignmentStore;

  var isDefaultAssignmentType = field.data.assignedTo === ((_assignmentStore$defa = assignmentStore.defaultOption) === null || _assignmentStore$defa === void 0 ? void 0 : _assignmentStore$defa.assignmentKey);
  var x = field.x,
      y = field.y,
      width = field.width,
      height = field.height;
  return jsx("g", rest, jsx("rect", {
    className: classnames(field.data.dataType === 'autofill' && {
      'bg-warning': true,
      'border-warning': selected
    }, field.data.dataType === 'manual' && {
      'bg-primary': isDefaultAssignmentType,
      'border-primary': isDefaultAssignmentType && selected,
      'bg-info': !isDefaultAssignmentType,
      'border-info': !isDefaultAssignmentType && selected
    }),
    fillOpacity: field.data.dataType === 'manual' && isDefaultAssignmentType ? '0.25' : '0.75',
    x: x,
    y: y,
    width: width,
    height: height
  }), jsx(ResizeHandle, {
    field: field
  }), field.data.dataType === 'autofill' && jsx("foreignObject", {
    x: x,
    y: y,
    width: width,
    height: height,
    pointerEvents: "none",
    opacity: "0.75",
    dominantBaseline: "middle",
    textAnchor: "middle"
  }, jsx("text", {
    style: {
      userSelect: 'none'
    },
    css: _ref2
  }, field.data.label)));
};

DrawableTextField.displayName = "DrawableTextField";
var DrawableTextField$1 = observer(DrawableTextField);
export default DrawableTextField$1;